import i18n from 'i18next';
import config from './config';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { telusLanguageDetector } from './i18n/telusLanguageDetector';

i18n.use(Backend)
    .use(telusLanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        fallbackNS: 'strings',
        ns: ['strings', 'accessibility'],
        defaultNS: 'strings',
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `${config.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
        },
    });

export default i18n;
